import type { PayloadAction } from '@reduxjs/toolkit';

import { SET_FEATURE_FLAGS, type FeatureFlags } from './types';

const initialState: FeatureFlags = {};

export function featureFlagsReducer(state = initialState, action: PayloadAction<FeatureFlags>): FeatureFlags {
	switch (action.type) {
		case SET_FEATURE_FLAGS:
			return { ...state, ...action.payload };
		default:
			return state;
	}
}
